import * as constants from "../core/core.constants";

export function formatFullUrl(serviceUrl: string, jwtToken: string = null): string {
    var res = constants.ServiceConfig.webApiUrl + serviceUrl;

    if (jwtToken) {
        res = res + "?jwtToken=" + jwtToken;
    }

    return res;
}

export function formatPersonCompetenceAttachmentServiceUrl(personCompetenceId: number) {
    return "PersonService/PersonCompetenceAttachment/" + personCompetenceId;
}

export function getPersonCompetenceFileDownloadUrl(personCompetenceId: number, jwtToken: string = null) {
    return formatFullUrl(formatPersonCompetenceAttachmentServiceUrl(personCompetenceId), jwtToken);
}


export function formatRequirementSectionAttachmentServiceUrl(requirementSectionId: number) {
    return "RequirementSectionService/RequirementSectionAttachment/" + requirementSectionId;
}

export function getRequirementSectionFileDownloadUrl(requirementSectionId: number) {
    return formatFullUrl(formatRequirementSectionAttachmentServiceUrl(requirementSectionId));
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/file.helper.ts